export default "__VITE_ASSET__DkHoF86l__"